export default "../fonts/akzidgrtskpromedcnd-webfont.075a884d187deb940717763a210d173b.woff2";